import {
  DTableProps,
  CombinedText,
  StatusChip,
  StatusChipColors,
  DarwinSelect,
  ACTIONS_COL_WIDTH,
  ActionsDropdown,
  STATUS_COL_WIDTH,
  DMenuProps,
} from '@darwin-ui';
import { TFunction } from 'i18next';
import { EditedUomItem, UnitOfMeasure } from 'types/unitOfMeasureTypes';
import styles from './index.module.css';
import { translateFormSelect } from 'utils/common';

export const getUomsColumns = (
  t: TFunction,
  actionItems: (item: UnitOfMeasure) => DMenuProps['items'],
  searchQuery: string,
  editedItems: Record<string, EditedUomItem>,
  onAliasesChange: (id: string, newAliases: string[]) => void
): DTableProps<UnitOfMeasure>['columns'] => [
  {
    title: t('uoms.columns.name'),
    dataIndex: 'name',
    key: 'name',
    sorter: true,
    render: (_: unknown, record: UnitOfMeasure) => (
      <CombinedText
        lines={1}
        text={translateFormSelect(t, record.name)}
        highlight={searchQuery}
      />
    ),
  },
  {
    title: t('uoms.columns.symbol'),
    dataIndex: 'symbol',
    key: 'symbol',
    sorter: true,
    render: (_: unknown, record: UnitOfMeasure) => (
      <CombinedText lines={1} text={record.symbol} highlight={searchQuery} />
    ),
  },
  {
    title: t('uoms.columns.aliases'),
    dataIndex: 'aliases',
    key: 'aliases',
    render: (_: any, record: UnitOfMeasure) => {
      const key = String(record.id);
      const currentAliases = editedItems[key]?.aliases ?? record.aliases ?? [];

      return (
        <DarwinSelect
          mode="tags"
          open={false}
          suffixIcon={null}
          value={currentAliases}
          onChange={(values: string[]) => onAliasesChange(key, values)}
          className={styles['uoms-aliases-select']}
        />
      );
    },
    width: 400,
  },
  {
    title: t('uoms.columns.active'),
    dataIndex: 'active',
    key: 'active',
    sorter: true,
    render: (_: any, record: UnitOfMeasure) => {
      const key = String(record.id);
      const isActive = editedItems[key]?.active ?? record.active;

      return (
        <div className={styles['uoms-actions']}>
          <StatusChip
            label={
              isActive ? t('uoms.columns.active') : t('uoms.columns.inactive')
            }
            color={isActive ? StatusChipColors.green : StatusChipColors.red}
          />
        </div>
      );
    },
    width: STATUS_COL_WIDTH,
  },
  {
    dataIndex: 'actions',
    key: 'actions',
    fixed: 'right',
    align: 'center',
    render: (_: any, record: UnitOfMeasure) => (
      <ActionsDropdown item={record} getMenuItems={actionItems} />
    ),
    width: ACTIONS_COL_WIDTH,
  },
];
